module.exports = __webpack_public_path__ + "img/loader.c03a7d8c.gif";